/* eslint-disable @typescript-eslint/no-use-before-define */
import type { PropDefaults, PropElement, PropTypes } from "..";
import Namespace from "./_index.scss";
import Rules from "./_rules.module.scss";

export const {
    NAME_CAROUSELPLATFORM,
    TYPE_CAROUSELPLATFORM,
    NAME_CONT_CAROUSELPLATFORM,
    TYPE_CONT_CAROUSELPLATFORM,
} = Namespace;

export const DIR_CAROUSELPLATFORM = {
    ltr: [Rules.horizontal, Rules.reverse],
    rtl: [Rules.horizontal, Rules.normal],
    ttb: [Rules.vertical, Rules.reverse],
    btt: [Rules.vertical, Rules.normal],
} as const;

export type DirectionCarousel = typeof DIR_CAROUSELPLATFORM;

export type KeyDirectionCarousel = keyof DirectionCarousel;

export const KEY_DIR_CAROUSELPLATFORM = Object.keys(DIR_CAROUSELPLATFORM) as KeyDirectionCarousel[];

export const ENUM_DIR_CAROUSELPLATFORM = KEY_DIR_CAROUSELPLATFORM.reduce(
    (acc, key) => ({ ...acc, [key]: key }),
    {} as { readonly [K in KeyDirectionCarousel]: K },
);

export type PropCarousel = PropElement & {
    /** Direction of the animation */
    direction?: KeyDirectionCarousel;
    /** Seconds it takes for an item in the carousel to do a full "rotation" */
    duration?: number;
};

export const DEF_CAROUSELPLATFORM: PropDefaults<PropCarousel> = {
    direction: "ltr",
    duration: 10,
};

export type PropTypesCarousel = PropTypes<PropCarousel, typeof DEF_CAROUSELPLATFORM>;

export const ERROR_CAROUSELPLATFORM = {
    NO_PARENT: `${NAME_CAROUSELPLATFORM}: A ParentElement could not be found.`,
    NO_CHILDREN: `${NAME_CAROUSELPLATFORM}: No children were available for parsing.`,
    NO_TARGET: `${NAME_CAROUSELPLATFORM}: Could not find a target for looping.`,
} as const;
